import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { VSpecRoutingModule } from './v-spec-routing.module';
import { VSpecPageComponent } from './v-spec-page.component';
//
// Child Module(s)
//
import { VSpecDetailModule } from './detail/v-spec-detail.module';
import { VSpecDealerOptionModule } from './dealer-options/v-spec-dealer-options.module';
import { VSpecLocalSpecialModule } from './local-special/v-spec-local-special.module';
import { VSpecProtectionProductDetailModule} from './protection-product-detail/v-spec-protection-product-detail.module';
import { VSpecProtectionProductsModule } from './protection-products/v-spec-protection-products.module';
import { VSpecService } from 'src/app/services/api/vspec.service';
import { VSpecDetailService } from './detail/v-spec-detail.service';
import { DownloadPDFResolver } from './resolvers/download-pdf.resolver';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    VSpecRoutingModule,
    VSpecDetailModule,
    VSpecDealerOptionModule,
    VSpecLocalSpecialModule,
    SharedModule,
    VSpecProtectionProductsModule,
    VSpecProtectionProductDetailModule

  ],
  exports: [
    VSpecPageComponent
  ],
  declarations: [
    VSpecPageComponent
  ],
  providers: [
    VSpecService,
    VSpecDetailService,
    DownloadPDFResolver
  ]
})
export class VSpecModule { }
